'use strict';

/**
 * Init years data for filters.
 *
 * @return {Array} ready data for years filter
 */
module.exports = function () {
    var list = [
            {
                state: false,
                title: '1960 - 1980',
                value: {start: 1960, end: 1980}
            },
            {
                state: false,
                title: gettext('Before') + ' 1960',
                value: {start: 1885, end: 1959}
            }
        ],
        date = new Date(),
        index, year;

    year = date.getFullYear();
    for ( index = 1981; index <= year; index++ ) {
        if ( year - index > 10 ) {
            list.unshift({
                state: false,
                title: index + ' - ' + (index + 9),
                value: {start: index, end: index + 9}
            });
            index += 9;
        } else {
            list.unshift({
                state: false,
                title: index,
                value: {start: index, end: index}
            });
        }
    }

    return list;
};
